import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: string;
  name: string;
  email: string;
  role?: string;
}

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  azureAccount: any | null;
  setUser: (user: User | null) => void;
  setAzureAccount: (account: any) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      azureAccount: null,
      setUser: (user) =>
        set({
          user,
          isAuthenticated: !!user,
        }),
      setAzureAccount: (account) =>
        set({
          azureAccount: account,
        }),
      logout: () =>
        set({
          user: null,
          isAuthenticated: false,
          azureAccount: null,
        }),
    }),
    {
      name: 'admin-auth-storage',
    }
  )
);

